import { render } from "./RelationshipTree.vue?vue&type=template&id=7a0125a9&scoped=true"
import script from "./RelationshipTree.vue?vue&type=script&lang=js"
export * from "./RelationshipTree.vue?vue&type=script&lang=js"

import "./RelationshipTree.vue?vue&type=style&index=0&id=7a0125a9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a0125a9"]])

export default __exports__